// extracted by mini-css-extract-plugin
var _1 = "separator__zNpp6";
export { _1 as "separator" }
